import React from 'react'
import Servicespages from './Servicespages'
import Menusectionpage from './Menusectionpage'
import Cars from './Cars'
import Herosectionpage from './Herosectionpage'

const Homepage = () => {
  return (
    <> 
<Herosectionpage/>
<Servicespages/>
<Cars/>
<Menusectionpage/>
    </>
  )
}

export default Homepage
